import createTypes from 'redux-create-action-types';

export default createTypes(
  'TOKEN_BALANCE_UPDATE',
  'TOKEN_BALANCE_UPDATE_ERROR',
  'TOKEN_BALANCE_UPDATE_SUCCESS',
  'TOKEN_DEPLOY',
  'TOKEN_DEPLOY_ERROR',
  'TOKEN_DEPLOY_SUCCESS',
  'TOKEN_FUNDED_UPDATE',
  'TOKEN_UBI_PAYOUT',
  'TOKEN_UBI_PAYOUT_ERROR',
  'TOKEN_UBI_PAYOUT_SUCCESS',
  'TOKEN_RESET',
  'TOKEN_TRANSFER',
  'TOKEN_TRANSFER_ERROR',
  'TOKEN_TRANSFER_SUCCESS',
  'TOKEN_UPDATE',
  'TOKEN_UPDATE_ERROR',
  'TOKEN_UPDATE_SUCCESS',
  'TOKEN_UPDATE_OTHER_TOKENS',
  'TOKEN_UPDATE_OTHER_TOKENS_LOADING',
  'TOKEN_UPDATE_OTHER_TOKENS_ERROR',
  'TOKEN_UPDATE_OTHER_TOKENS_SUCCESS',
);
